import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApproveTaskRequest } from "../task-detail/task-detail.model";
import { Observable } from "rxjs";
import { TaskApprovedResponse } from "../../interfaces/task-approved-response";
import { TaskApprovativo } from "../../interfaces/task-approvativo.model";

@Injectable({ providedIn: 'root' })
export class TaskDetailService {

    constructor(private http: HttpClient) {}

    loadTaskDetail(idTask: string): Observable<TaskApprovativo> {
        return this.http.get<TaskApprovativo>(`api/taskapprovativi/${idTask}`);
    }

    approveTask(req: ApproveTaskRequest): Observable<TaskApprovedResponse> {
        const formData = new FormData();

        formData.append('TaskId', req.taskId);
        formData.append('Outcome', req.outcome);
        formData.append('Notes', req.notes ?? '');
        formData.append('Priorita', req.priorita);

        const files = req.allegati ?? [];
        for (const file of files) {
          formData.append('Allegati', file, file.name);
        }
        
        return this.http.post<TaskApprovedResponse>(`api/taskapprovativi/approve`, formData);
    }

    downloadAttachmentService(idTask: string, idAttachment: string): Observable<any> {
        const url = `api/taskapprovativi/download/${idTask}/${idAttachment}`;
        return this.http.get(url, { responseType: 'blob' });
    }
}